import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/assets/img/pdf/newvation/newvation-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-e5d07e74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "landing_text_header text-5xl md:text-7xl" }, "NewVation"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      width: "100"
    })
  ])
], -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "title-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-3xl md:text-3xl",
  "data-cy": "pdf-coverpage-header"
}, " Bericht zum Masten ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-4xl" }, null, -1))
const _hoisted_8 = { class: "mt-2 text-xl flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-0 w-40" }, "Mast:", -1))
const _hoisted_10 = {
  class: "mt-0",
  "data-cy": "pdf-coverpage-street"
}
const _hoisted_11 = { class: "text-xl flex mt-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-0 w-40" }, "Anlage:", -1))
const _hoisted_13 = {
  class: "mt-0",
  "data-cy": "pdf-coverpage-begehungsdatum"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createBlock(_component_pdf_a4_page, {
    "no-margin": "",
    "pdf-key": _ctx.lang,
    class: "pdf-content"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.immobilie.name), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.immobilie.stadt), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["pdf-key"]))
}